import { IMatchDetailDTO } from "../../models/IMatch";

// "Winner of QF2": names the slot a later round is waiting on, numbered by the
// feeding match's position within its own round.
export const getDependentMatchLabel = (matches: IMatchDetailDTO[], matchId: string, isThirdPlace: boolean): string => {
  const match = matches.find((x) => x.id === matchId);
  const roundMatches = matches.filter((x) => x.round === match?.round);
  const matchIndex = roundMatches.findIndex((x) => x.id === matchId) + 1;

  if (match?.round) {
    switch (match.round) {
      case "Round of 16":
        return `Winner of R16-${matchIndex}`;
      case "Quarterfinals":
        return `Winner of QF${matchIndex}`;
      case "Semifinals":
        return `${isThirdPlace ? "Loser" : "Winner"} of SF${matchIndex}`;
      default:
        return `Winner of ${match.round}-${matchIndex}`;
    }
  }
  return "-";
};

// Copies of the preview matches with every empty slot named, for drawing the bracket.
// The originals are what gets submitted, so they are never touched.
export const withBracketPlaceholders = (matches: IMatchDetailDTO[]): IMatchDetailDTO[] =>
  matches.map((match) => {
    const isThirdPlace = match.round === "Third Place";
    const slotName = (name: string, parentId: string | undefined, opponentName: string) => {
      if (name) return name;
      if (parentId) return getDependentMatchLabel(matches, parentId, isThirdPlace);
      return opponentName ? "Bye" : "TBD";
    };

    return {
      ...match,
      homeTeamName: slotName(match.homeTeamName, match.parentMatch1Id, match.awayTeamName),
      awayTeamName: slotName(match.awayTeamName, match.parentMatch2Id, match.homeTeamName),
    };
  });
